import React from 'react';
import { Empty, Button } from 'antd';
import { PlusOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';

interface EmptyStateProps {
  title?: string;
  description?: string;
  createPath?: string;
  createText?: string;
}

const EmptyState: React.FC<EmptyStateProps> = ({
  title = '暂无数据',
  description = '当前没有任何数据',
  createPath,
  createText = '创建'
}) => {
  const navigate = useNavigate();
  
  return (
    <div style={{ padding: '50px 0', textAlign: 'center' }}>
      <Empty
        image={Empty.PRESENTED_IMAGE_SIMPLE}
        description={
          <span>
            <strong>{title}</strong>
            <br />
            {description}
          </span>
        }
      >
        {createPath && (
          <Button 
            type="primary" 
            icon={<PlusOutlined />} 
            onClick={() => navigate(createPath)}
          >
            {createText}
          </Button>
        )}
      </Empty>
    </div>
  );
};

export default EmptyState; 